import React, { Component } from 'react';
import { PDFDownloadLink } from '@react-pdf/renderer';
import { Modal, Button } from 'react-bootstrap';
import { ShareFill } from 'react-bootstrap-icons';
import moment from "moment-timezone";
import { isEmpty } from 'lodash';
import QRCode from 'qrcode.react';
import { connect } from 'react-redux';
import ErrorQrCode from '../assets/images/no-qr-code.png';
import Home from '../assets/SVG/buttons/Home-button-big.svg';
import Info from '../assets/SVG/buttons/info-icon.svg';
import TestButton from '../assets/SVG/buttons/Test-button.svg';
import ErrorIcon from '../assets/SVG/icons/error-icon.svg';
import config from '../config';
import '../styles/result.css';
import CovidResultGradient from '../components/CovidResultGradient';
import CovidResultPDFV2 from '../components/CovidResultPDFV2';
import { getUserStatus } from '../api';

export class ResultV2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isReady: false,
      isCovid: false,
      date: moment().format('YYYY-MM-DD'),
      time:  moment().format('hh:mm A'),
      errMsg: "",
      getUser: this.props.user,
      response: this.props.location.state?.response,
      message: "",
      pdfData: null,
      pdfUrl: null,
      open: false,
      showTestButton: true,
    }
  }

  componentDidMount(){
    document.title = "COVID-19 Result";
    this.displayResults(this.state.response);
    this.checkStatus();
  }

  checkStatus = async () => {
    const calendarData = {
      days: [],
      dates: [],
      months: [],
      weekStart: moment()
        .tz(this.props.user.timezone || config.defaultTimezone)
        .clone()
        .startOf("isoWeek"),
      weekEnd: moment()
        .tz(this.props.user.timezone || config.defaultTimezone)
        .clone()
        .endOf("isoWeek"),
      weekStart_month: "",
      weekEnd_month: "",
      monthEndDate: moment()
        .tz(this.props.user.timezone || config.defaultTimezone)
        .clone()
        .endOf("month")
        .format("DD"),
      monthEnd: moment()
        .tz(this.props.user.timezone || config.defaultTimezone)
        .clone()
        .endOf("month"),
      monthStart: moment()
        .tz(this.props.user.timezone || config.defaultTimezone)
        .clone()
        .startOf("month"),
      today_date: moment(new Date())
        .tz(this.props.user.timezone || config.defaultTimezone)
        .add(0, "days")
        .format("DD"),
      yesterday: moment(new Date())
        .tz(this.props.user.timezone || config.defaultTimezone)
        .add(-1, "days")
        .format("DD"),
      today_month: moment(new Date())
        .tz(this.props.user.timezone || config.defaultTimezone)
        .add(0, "days")
        .format("MMM"),
      yesterday_month: moment(new Date())
        .tz(this.props.user.timezone || config.defaultTimezone)
        .add(-1, "days")
        .format("MMM"),
      year: new Date().getFullYear(),
    }
    const weekFrom = moment(calendarData.weekStart)
      .tz(this.props.user.timezone || config.defaultTimezone)
      .format("YYYY-MM-DDTHH:mm:ss.SSSZ");
    const weekTo = moment(calendarData.weekEnd)
      .tz(this.props.user.timezone || config.defaultTimezone)
      .format("YYYY-MM-DDTHH:mm:ss.SSSZ");
    const monthFrom = moment(calendarData.monthStart)
      .tz(this.props.user.timezone || config.defaultTimezone)
      .format("YYYY-MM-DDTHH:mm:ss.SSSZ");
    const monthTo = moment(calendarData.monthEnd)
      .tz(this.props.user.timezone || config.defaultTimezone)
      .format("YYYY-MM-DDTHH:mm:ss.SSSZ");

    const userStatus = await getUserStatus({
      uid: this.props.user.uid,
      accountType: this.props.user.accountType,
      affiliateLinkId: this.props.user.affiliateLinkId,
      weekFrom,
      weekTo,
      monthFrom,
      monthTo
    });

    const totalTestByPeriod = userStatus.totalTestByPeriod;
    const testLimitByPlan = userStatus.testLimitByPlan;
    const totalTestCounts = userStatus.totalTestCounts;

    const accountType = this.props.user?.accountType;
    const trialTestLimit = this.props.user?.trialTestLimit;
    const trialEnd = this.props.user?.trialEnd;
    switch(accountType) {
      case "trial":
        if(moment(trialEnd).isBefore() || totalTestCounts >= trialTestLimit) {
          this.setState({ showTestButton: false })
        }
        break;
      case "active":
        if(totalTestByPeriod >= testLimitByPlan) {
          this.setState({ showTestButton: false })
        }
        break;
    }
  }

  displayResults = (response) => {
    if (response) {
      let errorMsg = "";
      if (response.error) {
        errorMsg = response.error;
      } else if (response.probability) {
        this.setState({ message: response.quality_message })

        if (response.covid_status === "Positive") {
          this.setState({isCovid: true });
        } else if (response.covid_status === "Negative") {
          this.setState({isCovid: false});
        } else {
          errorMsg = "We cannot predict confidently based on your eyes images. Please change your location or choose different images and try again.";
        }
      } else {
        errorMsg = "We cannot predict confidently based on your eyes images.";
      }
      this.setState({ errMsg: errorMsg })

      if(isEmpty(errorMsg)) {
        const qrCode = document.getElementById('result_qrcode');
        const serializedSVG = new XMLSerializer().serializeToString(qrCode);

        const img = new Image();
        img.onload = () => {
          this.getPdfData(img, errorMsg)
        };
        img.src = `data:image/svg+xml;base64,${btoa(serializedSVG)}`;
      }
    } else {
      this.props.history.push('/home');
    }
  };

  getArrowPos = async () => {
    if(this.state.response?.threshold) {
        const _probability = parseFloat(this.state.response?.probability.toFixed(2));
        if(_probability < this.state.response?.threshold) {
          let high = parseFloat((this.state.response?.threshold - 0.01).toFixed(2));
          let low = parseFloat((high - 0.09).toFixed(2));
        let pos = 35;
        for(let i=0; i<5; i++) {
              if(_probability >= low && _probability <= high) {
            return pos
          }
              high = parseFloat((low - 0.01).toFixed(2));
              low = parseFloat((high - 0.09).toFixed(2));
          pos -= 5;
        }
        return pos;
      } else {
        let low = this.state.response?.threshold;
            let high = parseFloat((low + 0.09).toFixed(2));
        let pos = 65;
        for(let i=0; i<5; i++) {
                if(_probability >= low && _probability <= high) {
            return pos
          }
                low = parseFloat((high + 0.01).toFixed(2));
                high = parseFloat((low + 0.09).toFixed(2));
          pos += 5;
        }
        return pos;
      }
    } else {
      return this.state.isCovid ? 75 : 25;
    }
  }

  getPdfData = async (img, errorMsg) => {
    const questionnaire = this.props.location.state?.qtn;
    const isASymp = questionnaire ? questionnaire?.cough === "False" &&  questionnaire?.headache === "False" &&  questionnaire?.weakness === "False" &&  questionnaire?.sore_throat === "False" :  true;
    const pos = await this.getArrowPos();

    const canvasElement = document.createElement('canvas');
    canvasElement.width = img.width
    canvasElement.height = img.height
    const context = canvasElement.getContext('2d');
    context.drawImage(img, 0, 0);
      const qrcodeData = canvasElement.toDataURL();
    this.setState({
      isReady: true,
      pdfData: {
        pictures: this.props.location.state?.profile,
        svgData: qrcodeData,
        name: `${this.state.getUser?.firstName} ${this.state.getUser?.lastName}`,
        date: `${this.state.date} ${this.state.time}`,
        status: this.state.isCovid,
        errMsg: errorMsg,
        isASymp,
        pos
      }
    })
  }

  onDownloadPDF = (url) => {
    this.setState({ pdfUrl: url, open: true });
  };

  handleClose = () => {
    this.setState({ open: false })
  }

  shareResult = () => {
    const currentTimestamp = new Date().getTime();
    const link = document.createElement('a');
    link.href = this.state.pdfUrl;
    link.download = `COVID-Result-${currentTimestamp}.pdf`;
    link.click();
    this.setState({ open: false })
  }

  gotoHome = () => {
    // this.props.history.push('/home');
    window.location.replace('/home') // temp hotfix for memory leak for webgl
  }
  gotoInfo = () => {
    // this.props.history.push('/info');
    window.location.replace('/info') // temp hotfix for memory leak for webgl
  }
  gotoTestSelection = () => {
    // this.props.history.push("/testSelection")
    window.location.replace('/testSelection') // temp hotfix for memory leak for webgl
  }

  renderUser = () => {
    return (
      <div className="test-record">
        {isEmpty(this.state.errMsg) ? (
          <div className="bg-white">
            <QRCode
              id="result_qrcode"
              value={config.QRcode_URL + "/covid/" + this.state.response?.test_id}
              size={100}
              renderAs={"svg"}
            />
          </div>
        ) : (
          <div>
            <img src={ErrorQrCode} alt="no-qrcode" />
          </div>
        )}
        <div className="p-2">
          <span>Name: </span>
          <span className="label">
              {this.state.getUser?.firstName} {this.state.getUser?.lastName}
            </span>
        </div>
        <div>
          <span>Test Time: </span>
          <span className="label">
              {this.state.date} {this.state.time}
            </span>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className="container">
        <div className="main result" data-testid="result">
          <div className="header">
            <img src={Home} alt="Home" className="hand-pointer" onClick={this.gotoHome} />
            <img src={Info} alt="Info" className="hand-pointer" onClick={this.gotoInfo} />
          </div>
          <div className="card" data-testid="card">
            {this.state.isReady && (
              <div className="share_btn">
                <PDFDownloadLink
                  document={<CovidResultPDFV2 data={this.state.pdfData} />}
                  onClick={(e) => e.preventDefault()}
                  fileName="covid_result.pdf"
                >
                  {({ blob, url, loading, error }) => {
                    return (
                      <div className="share_icon rounded-circle" onClick={(e) => this.onDownloadPDF(url)}>
                        <ShareFill size={20} />
                      </div>
                    );
                  }}
                </PDFDownloadLink>
              </div>
            )}

            <div className="result-detail">
              <div className="test-record">
                <div className="profile-photos">
                  <img src={this.props.location.state?.profile[0]} className="profile mirror" alt="profile" />
                  <img src={this.props.location.state?.profile[1]} className="profile mirror" alt="profile" />
                  <img src={this.props.location.state?.profile[2]} className="profile mirror" alt="profile" />
                  <img src={this.props.location.state?.profile[3]} className="profile mirror" alt="profile" />
                </div>
              </div>

              <div className="covid">
                {
                  isEmpty(this.state.errMsg) ? <CovidResultGradient
                    threshold={this.state.response?.threshold}
                    probability={this.state.response?.probability}
                    isCovid={this.state.isCovid}
                    questionnaire={this.props.location.state?.qtn}
                  >
                    {this.renderUser()}
                  </CovidResultGradient> : this.renderUser()
                }

                {!!this.state.message && (
                  <div>
                    <img src={ErrorIcon} alt="error icon" />
                    <span className="fpError" data-testid="fpMessage">
                          {this.state.message}
                        </span>
                  </div>
                )}
              </div>
            </div>

            {this.state.errMsg && <p>{this.state.errMsg}</p>}
          </div>
          {this.state.showTestButton && (
            <div className="buttons-div">
              <div className="button" data-testid="test-button">
                <img
                  src={TestButton}
                  alt="start-test"
                  width="100px"
                  height="100px"
                  onClick={this.gotoTestSelection}
                />
                <span>Test Again </span>
              </div>
            </div>
          )}

          {/* <div className="buttons-div">
                <div className="button" data-testid="test-button">
                  <img
                    src={TestButton}
                    alt="start-test"
                    width="100px"
                    height="100px"
                    onClick={this.gotoTestSelection}
                  />
                  <span>Start</span>
                </div>
              </div> */}

          <Modal
            animation={false}
            show={this.state.open}
            onHide={this.handleClose}
            centered
            backdrop="static"
            className="warning_modal"
          >
            <Modal.Header>
              <Modal.Title>COVID-19 Screening Result Sharing</Modal.Title>
            </Modal.Header>
            <Modal.Body className="body">
              <p>
                I understand that by sharing this information I am disclosing personal health information to the
                recipient and that the information shared is no longer protected by the iSelfie application privacy
                and security controls.
              </p>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" id="cancel" onClick={this.handleClose}>
                Cancel
              </Button>
              <Button variant="primary" id="continue" onClick={this.shareResult}>
                Share
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({ user: state.user});
export default connect(mapStateToProps, null)(ResultV2);
